import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './loader.scss';

class Loader extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    inline: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    loading: true,
    inline: true,
  };

  render() {
    if (this.props.loading) {
      return (
        <div className={cx(this.props.className, { inline: this.props.inline })}>
          <div className="loader__overlay absolute w-full h-full pin-l pin-t z-50 bg-white opacity-75" />
          <div className="loader__spinner absolute z-50">
            <svg
              width="65px"
              height="65px"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg">
              <circle
                fill="none"
                strokeWidth="6"
                strokeLinecap="round"
                cx="33"
                cy="33"
                r="30"
              />
            </svg>
          </div>
          {this.props.children}
        </div>
      );
    }
    return <Fragment>{this.props.children}</Fragment>;
  }
}

export default  Loader;
